import React, { useEffect } from 'react'

import { Renew/*, SearchInput*/ } from 'components'
import { StockSelector } from '../StockSelector'
import {
  LabBtn,
  LabList,
  LabTab,
  LabTitle,
  Manual,
  Outlink,
  StockFavorite,
} from './components'
import data from 'components/ShortcutKey/data'

const Toolbar = (props) => {
  const {
    lab,
    currentLabID,
    currentLab,
    category,
    stock,
    isMyFavNeeded,
    isStockInputNeeded,
    isTaiwanOnly,

    searchlistLabResult,
    listLabData,

    history,

    is_mobile,
    width,
    side_menu_hidden,

    // onCurrentLabSet,
    // onTabChange,

    onSearchGetRequest,
    onSingleSearch,
  } = props;
  const available = currentLab?.available;

  useEffect(() => {
    if (!lab || !lab.available) { return; }

    // const idx = LabDataHandler.getActiveLabIndex(currentLabID, lab);

    // onTabChange(idx);

    if (data[lab?.pathname]) {
      let currHandleKeys = [];

      const matchKeyCombo = (key, currKeys) => {
        const keys = key.split('+');
        const modifiers = {
          A: currKeys.includes('AltLeft') || currKeys.includes('AltRight'),
          C: currKeys.includes('ControlLeft') || currKeys.includes('ControlRight'),
          S: currKeys.includes('ShiftLeft') || currKeys.includes('ShiftRight'),
        };

        const modifierKey = keys[0];
        const primaryKey = keys[1];

        const currModifierKey = Object.keys(modifiers).find(key => modifiers[key] === true);
        const currPrimaryKey = currKeys.map(i => (
          i.startsWith('Key') ?
            i.slice(3) : (i.startsWith('Digit') ? i.slice(5) : (i === 'Backquote' ? '`' : null))))
                .filter(i => i !== null)[0];

        return (currModifierKey === modifierKey && currPrimaryKey === primaryKey) || currKeys.includes(key);
      };

      const handleKeyDown = (e) => {
        if (!currHandleKeys.includes(e.code)) currHandleKeys.push(e.code);

        const ACSCode = ['AltLeft', 'AltRight', 'ControlLeft', 'ControlRight', 'ShiftLeft', 'ShiftRight'];

        const hasModifierKey = currHandleKeys.some(key => ACSCode.includes(key));
        const primaryKeys = currHandleKeys.filter(key => !ACSCode.includes(key));

        const isComboKey = hasModifierKey && primaryKeys.length > 0 && !primaryKeys.find(i=>i.startsWith('F'));
        const isFKey = !hasModifierKey && primaryKeys.length === 1 && primaryKeys[0]?.startsWith('F');

        if (isComboKey ^ isFKey) {
          for (const item of data[lab?.pathname]) {
            for (const keyCombo of item.key) {
              if (matchKeyCombo(keyCombo, currHandleKeys)) {
                e.preventDefault();

                history.push(`/lab/dashboard/${lab?.pathname}/${item.id}`);
                
                return;
              }
            }
          }
        }
      };

      const handleKeyUp = (e) => {
        currHandleKeys = currHandleKeys.filter(key => key !== e.code);
      };

      const handleKeyReset = (e)=>{
        currHandleKeys = [];
      }

      window.addEventListener('keydown', handleKeyDown);
      window.addEventListener('keyup', handleKeyUp);
      window.addEventListener('blur', handleKeyReset);

      return () => {
        window.removeEventListener('keydown', handleKeyDown);
        window.removeEventListener('keyup', handleKeyUp);
        window.removeEventListener('blur', handleKeyReset);
      };
    }
  }, [ lab, history, /* currentLabID, onTabChange */ ])

  return (
    <div className='fixed-bar'>

      {(lab && lab.title) && (
        <div className='toolbar'>
          {/* title */}
          <LabTitle lab={lab} history={history} /*onTabChange={onTabChange}*/ />

          {/* tabs */}
          {!is_mobile && (
            <LabTab
              lab={lab}
              currentLabID={currentLabID}

              sideMenuHidden={side_menu_hidden}
              width={width}
              history={history}

              // onCurrentLabSet={onCurrentLabSet}
            />
          )}

          <LabList
            lab={lab}
            labID={lab?.id}
            currentLabID={currentLabID}

            search
            listLabData={listLabData}
            searchlistLabResult={searchlistLabResult}

            history={history}

            // onCurrentLabSet={onCurrentLabSet}
            onSearchGetRequest={onSearchGetRequest}
            onSingleSearch={onSingleSearch}

            isMobile={is_mobile}
          />


          <LabBtn lab={lab} labID={lab?.id} />

          {/* renew */}
          <Renew
            className='dashboard-renew'
            btnName='續約優惠'
            product={lab ? lab.master : null}
            // history={history}
          />
        </div>
      )}

      {isMyFavNeeded && <StockFavorite />}

      {(isStockInputNeeded && (!currentLab || category !== 5)) && (
        <div className={`dashboard-toolbar ${!available ? 'expired' : ''}`}>
          <StockSelector
            stock={stock}
            favoriteBtn={true}
            isTaiwanOnly={isTaiwanOnly}
          />

          {lab && (
            <div className='manual-link-container'>
              <Manual lab={lab} isMobile={is_mobile} />

              <Outlink lab={lab} isMobile={is_mobile} />
            </div>
          )}
        </div>
      )}
    </div>
  );
}


export { Toolbar }
